//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'InputField',
  props: {
    value: '',
    type: String,
    label: String,
    name: String,
    placeholder: String,
    min: '',
    tooltip: '',
    error: '',
    max: false,
    count: false,
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value);
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/fields/InputField.vue